import React, { useRef, useState } from 'react'
import { Modal, Carousel } from 'react-bootstrap'
import styled from 'styled-components'
import agendaImage from '../../images/event/agenda.png'
import { LazyLoadImage, LazyLoadComponent } from 'react-lazy-load-image-component';
import { COLORS } from '../../styles/theme'
import config from '../../config'
import { useDispatch } from 'react-redux'

const StyledModal = styled(Modal)`
  text-align: center;
  color: ${COLORS.primary};

  .modal-dialog {
    min-width: 75%;
  }
  .modal-content {
    background-color: rgba(255, 255, 255, 0.9);
    border: none;
    border-radius: 0;
    padding: 24px 36px;
    margin-bottom: 24px;

    .modal-header {
      border: none;
      text-align: left;
      .modal-title {
        font-size: 36px;
        font-weight: bold;
        font-style: italic;
      }
      button {
        font-size: 36px;
        opacity: 1;
        color: rgba(0, 0, 0, 0.55);
      }
    }
    .header-section {
      margin-top: 16px;
      button {
        border: none;
        background: transparent;
        color: ${COLORS.primary};
        display: block;
      }
      .navigation {
        height: 100%;
        display: flex;
        justify-content: space-around;
        align-items: flex-end;
        button {
          width: 150px;
          background: white;
          color: ${COLORS.primary};
          border: 2px solid ${COLORS.primary};
          border-radius: 12px;
          padding: 6px 16px;
          display: flex;
          justify-content: space-around;
          align-items: center;
          h5 {
            margin: 0;
          }
          &:hover {
            /* background: #FFAD2C; */
            background: linear-gradient(to right, #F8C723, #E7B119, #FDF382, #FEE15C, #FFDA4C);
          }
        }
      }
    }
    .divider {
      background: ${COLORS.primary};
      height: 4.5px;
      margin: 32px 0;
    }
  }
  .back-top {
    border: none;
    border-radius: 12px;
    background: #002060;
    position:absolute;
    bottom: 0;
    right: 0;
    svg {
      width:50;
      height:50;
    }
  }
  .modal-body {
    padding-bottom: 36px;
  }
`
const StyledCarousel = styled(Carousel)`
  .carousel-control-next, 
  .carousel-control-prev {
    opacity: 1;
  }

  .carousel-control-prev {
    left: -6%;
  } 
  .carousel-control-next {
    right: -6%;
  }
  span.carousel-control-next-icon, span.carousel-control-prev-icon {
    padding: 12px;
    background-color: #E7B119;
    border: 6px solid #E7B119;
    border-radius: 4px;
  }

`

export default function ProgrammeModal({ showModal, hideSchedule, currentUser }) {
  const speakerSec = useRef()
  const agendaSec = useRef()
  const startModal = useRef()

  const scrollTop = (ref) =>{
    ref.current.scrollIntoView({ behavior: 'smooth' })
  };
  
  return (
    <StyledModal
      show={showModal}
      onHide={hideSchedule}
      size="xl"
      aria-labelledby="menu-modal"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>MENU</Modal.Title>
        <span ref={startModal}></span>
      </Modal.Header>
      <Modal.Body>
        <div className="header-section">
          <div className="navigation">
            <button onClick={()=>scrollTop(agendaSec)}>
              <h5>Agenda</h5>
            </button>
            <button onClick={()=>scrollTop(speakerSec)}>
              <h5>Speakers</h5>
            </button>
          </div>
        </div>
        <div className="divider"></div>
        <span ref={agendaSec}></span>
        <div>
          <LazyLoadImage effect="black-and-white" src={config.assets.agenda} width="100%" alt="event agenda" />
        </div>
        <div className="divider"></div>
        <div>
          <div ref={speakerSec}></div>
          <LazyLoadComponent>
            <StyledCarousel>
              {
                config.assets.speakers.map((image, index)=>(
                  <Carousel.Item key={`speakerinfo-${index}`} >
                    <img 
                      src={image} 
                      className="d-block mx-auto"
                      width="100%" 
                      alt={`speakerinfo-${index}`}
                    />
                  </Carousel.Item>
                ))
              }
            </StyledCarousel>
          </LazyLoadComponent>
        </div>
        <button onClick={()=>scrollTop(startModal)} className="back-top">
          <svg width="45" height="45" viewBox="0 0 45 45">
            <g transform="translate(-1767 -3747)">
              <g transform="translate(120 -2428)">
                <path d="M22.175,9.358a1.43,1.43,0,0,0-1.43-1.43H5.063l5.813-5.42A1.43,1.43,0,1,0,8.923.421L.455,8.311a1.43,1.43,0,0,0,0,2.091L8.923,18.3A1.43,1.43,0,1,0,10.875,16.2L5.063,10.788H20.746A1.43,1.43,0,0,0,22.175,9.358Z" transform="translate(1678.681 6187) rotate(90)" fill="#ffad2c"/>
              </g>
            </g>
          </svg>
        </button>
      </Modal.Body>
    </StyledModal>
  )
}
